<template>
	<router-view></router-view>
</template>
<script>

</script>
<style lang="scss">
	@import url("//at.alicdn.com/t/c/font_4755430_7oci5f1u6j2.css"); //at.alicdn.com/t/c/font_4755430_raliftt6nsg.css
	@import "@/assets/css/base.scss";
	@import "@/assets/css/style.scss";
</style>